import { Autocomplete, Box, Button, CircularProgress, FormControl, Grid, IconButton, InputAdornment, MenuItem, OutlinedInput, Paper, Select, Stack, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { createPosDevices, getPosDevices } from 'src/services/pos';
import { useAuthContext } from 'src/auth/useAuthContext';
import useModalControl from 'src/components/cards/useModalControl';
import AddDevice from './AddDevice';
import usePagination from 'src/hooks/usePagination';
import { notify } from 'src/components/notify';
import { debounce } from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import { VendorContext } from 'src/contexts/VendorContext';
import CustomTable from 'src/components/CustomTable';
import Pagination from 'src/components/pagination';
import NoData from 'src/components/no-data/NoData';
import Logo from '../../assets/images/no-data/no_campaign_dash.svg'
import dayjs from 'dayjs';
export default function DevicesAdd({ id }) {
    const { user } = useAuthContext()
    const { vendors, getVendor } = useContext(VendorContext);
    const [vendorId, setVendorId] = useState({ _id: "", name: "" })
    const { open, handleCloseModal, handleOpenModal } = useModalControl()
    const [reload, setReload] = useState(false)
    const { page, setPage, page_size, total_records, setTotal_records, totalPages, setTotalPages, handlePageSize } = usePagination()
    const [search, setSearch] = useState("")

    useEffect(() => {
        const fetchVendor = async () => {
            try {
                await getVendor(0, true);
            } catch (error) {
                console.error(error);
            } finally {
            }
        };
        fetchVendor();
    }, []);
    const [editData, setEditData] = useState()
    const [devices, setDevices] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const response = await getPosDevices(user, vendorId?._id, page, page_size, search)
                setDevices(() => {
                    return [...(response?._payload || [])]
                })
                setTotal_records(response?.total_records);
                setTotalPages(response?.totalPages);

            } catch (err) {
                console.log(err);

            } finally {
                setLoading(false)
            }

        }

        fetchData()
    }, [id, reload, page, search, vendorId?._id])
    const handleSubmit = async (row) => {
        try {

            let data = {
                deviceId: row.deviceId,
                name: row.name,
                status: row.status,
                id: row._id,
                isDeleted: true,
                vendor: id
            }

            const method = "put"
            const url = "/service/accounts_service/v1/accounts/pos/update"
            const response = await createPosDevices(user, data, method, url,)

            if (response) {
                setPage(0)
                setReload((prev) => !prev)
                notify("Device Deleted Successfully", "success")
            }

        } catch (err) {
            console.log(err);

        }
    }

    const handleSearch = debounce((e) => {
        setSearch(e.target.value)
    }, 800)
    const columns = [
        { id: "Sl NO.", label: "Sl NO", renderCell: (_, index) => index + 1 },
        { id: "Vendor Name", label: "Partner Name", renderCell: (row) => row?.vendor?.name || "-" },
        { id: "deviceId", label: "Device ID" },
        { id: "display_name", label: "Display Name", renderCell: (row, index) => row?.display_name || "-" },
        { id: "name", label: "Device Name", },
        { id: "store_id", label: "Store ID", renderCell: (row, index) => row?.store_id || "-" },
        { id: "Status", label: "Status", renderCell: (row, index) => (!row?.isDeleted && row?.status) ? "Active" : "In Active" },
        { id: "createdAt", label: "Created At", renderCell: (row, index) => dayjs(row?.createdAt).format("DD/MM/YYYY hh:mm A") },
        {
            id: "Action", label: "Action", renderCell: (it) => {
                return <Stack direction="row" justifyContent="center">
                    {!it?.isDeleted && <IconButton color="primary" onClick={() => {
                        setEditData(it)
                        handleOpenModal()
                    }}>
                        <EditIcon />
                    </IconButton>}
                    {!it?.isDeleted && <IconButton color="error" onClick={() => handleSubmit(it)}>
                        <DeleteIcon />
                    </IconButton>}
                    {
                        it?.isDeleted ? <Typography color="error" variant="body1">Deleted</Typography> : ""
                    }
                </Stack>
            }
        },
    ]
    return (
        <Stack spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant='h5'>Pos Devices</Typography>
                <Stack direction="row">
                    <Button variant="contained" onClick={handleOpenModal}>Add Device</Button>
                </Stack>
            </Stack>
            <Stack mb={2} spacing={1} >

                <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
                    <TextField
                        fullWidth
                        id="Search"
                        variant="outlined"
                        placeholder="Search"
                        backgroundColor="#FFFFFF"
                        onChange={handleSearch}
                        sx={{ maxWidth: { xs: "100%", md: '256px' } }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Stack spacing={1} sx={{ width: "250px" }}>
                        <Autocomplete
                            id="checkboxes-tags-demo"
                            options={[...vendors]}
                            limitTags={2}
                            getOptionLabel={(option) => option.name}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        {option.name}
                                    </li>
                                );
                            }}
                            value={vendorId}
                            onChange={(_, val) => {
                                setPage(0)
                                setVendorId(val)
                            }}

                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                                <TextField {...params} label="Select Partners"
                                    placeholder="Select Partners" />
                            )}
                        />
                    </Stack>
                </Stack>
            </Stack>
            {(!devices?.length && !loading) && <NoData helperText="No data found.." src={Logo} />}
            {devices?.length > 0 && <CustomTable rows={devices} columns={columns} loading={loading} />}
            {devices?.length > 0 && <Stack
                direction="row"
                sx={{ width: '100%', p: { xs: 0, sm: 3 } }}
                alignItems="center"
                flexWrap="wrap"
                justifyContent="space-between"
                gap={1}
            >
                <Box
                    minWidth={220}
                    width={{ xs: '100%', sm: 'max-content' }}
                    alignSelf={{ xs: 'center', sm: 'auto' }}
                >
                    <Typography
                        sx={{ textAlign: { xs: 'center', sm: 'normal' } }}
                        color="primary"
                        variant="body1"
                    >

                        {`Showing ${page !== 0 ? page * page_size : 1}  to ${(page + 1) * page_size > total_records ? total_records : (page + 1) * page_size
                            } of ${total_records} entries`}


                    </Typography>
                </Box>
                <Box sx={{ order: { xs: 2, sm: 0 } }} flex={{ xs: 0, sm: 1 }}>
                    <FormControl sx={{ maxWidth: 'max-content', flexGrow: 1 }} fullWidth>
                        <Select
                            className="custom-select"
                            sx={{
                                '&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.custom-select':
                                {
                                    height: '37px',
                                },
                            }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={page_size}
                            onChange={handlePageSize}
                            color="primary"
                            renderValue={() => `${page_size} per page`}
                        >
                            <MenuItem value={15}>15</MenuItem>
                            <MenuItem value={25}>25</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={75}>75</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Pagination page={page} setPage={setPage} totalPages={totalPages} />
            </Stack>}
            {open && <AddDevice setPage={setPage} open={open} close={() => { handleCloseModal(); setEditData("") }} id={id} setReload={setReload} editData={editData} vendors={vendors} />}
        </Stack>
    )
}
